import styled from 'styled-components';

import Button from '@/components/Button';

export const Container = styled.div`
  min-width: 290px;
  max-width: 600px;
  width: 100%;

  background-color: #ffffff;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.15);
`;

export const Header = styled.header`
  position: relative;
  min-height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 6px 0 #d0d0d0;
  padding: 0 15px;
`;

export const HeaderTitle = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  padding-right: 25px;

  flex-grow: 1;
`;

export const Content = styled.div`
  padding: 20px;
  position: relative;
`;

export const Footer = styled.footer`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 20px;
  border-top: 1px solid #ccc;
`;

export const FooterButton = styled(Button)`
  margin-left: 20px;
  height: 40px;
  width: 100px;
`;
